import { render } from "./EditProduct.vue?vue&type=template&id=1ac26e3a&scoped=true&ts=true"
import script from "./EditProduct.vue?vue&type=script&lang=ts"
export * from "./EditProduct.vue?vue&type=script&lang=ts"

import "./EditProduct.vue?vue&type=style&index=0&id=1ac26e3a&lang=css"
import "./EditProduct.vue?vue&type=style&index=1&id=1ac26e3a&lang=scss&scoped=true"

import exportComponent from "/home/uat/uatdan_yrshop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac26e3a"]])

export default __exports__